export default "__VITE_ASSET__DsSc6a9L__"